/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, {useCallback, useEffect} from 'react';
// redux
import {useSelector, useDispatch} from 'react-redux';
import { MIGRATION_READY, MIGRATION_ERROR, DEFAULT_MIGRATION_STATUS, MIGRATION_STARTED, MIGRATION_COMPLETED, MIGRATION_NOT_REQUIRED } from "../../../../../../state/slices/engagement";
import { fetchMigrationStatus, startMigration } from "../../../../../../state/thunks/engagement";
// material
import {InlineMessage, Button} from '@insticator/insticator-ui';
import SectionCard from '../../../../../../material/expandablesection/sectioncard/sectioncard';
import SectionGroup from '../../../../../../material/expandablesection/sectiongroup/sectiongroup';
import SectionGroupDescription from '../../../../../../material/expandablesection/sectiongroupdescription/sectiongroupdescription';
import { Loader } from '@insticator/insticator-ui';
// styles
import injectSheet from 'react-jss';
import styles from './sentiment_styles';



/* ========== ~~~~~~~~~~ ADVANCED SETTINGS - SENTIMENT ~~~~~~~~~~ ========== */
const SentimentAdvancedSettings = injectSheet(styles)((props) => {
  const dispatch = useDispatch();
  const {
    engagement: {
      migrationStatus,
      articleSentimentUnitUUID,
    },
  } = useSelector((state) => state);

  useEffect(() => {
    if (!articleSentimentUnitUUID || !migrationStatus || migrationStatus !== MIGRATION_STARTED) return

    const interval = setInterval(() => {
      dispatch(fetchMigrationStatus(articleSentimentUnitUUID))
    }, 60 * 1000);

    return () => clearInterval(interval);
  }, [migrationStatus, dispatch, articleSentimentUnitUUID]);

  const handleMigrate = useCallback(() => {
    if (!articleSentimentUnitUUID) return;
    dispatch(startMigration(articleSentimentUnitUUID))
  }, [articleSentimentUnitUUID, dispatch])

  return (
    <SectionCard klass={`${props.classes.sentimentadvancedsettings}`}>
      <SectionGroup>
        <SectionGroupDescription
          title={'Article Sentiment'}
          description={'Migrate historical Reactions data to new Article Sentiment unit for this publisher'}
        />
      </SectionGroup>
      <br/>
      {[MIGRATION_READY, DEFAULT_MIGRATION_STATUS].includes(migrationStatus) && <InlineMessage
        key={'meow'}
        display={true}
        name={'migrationmessage'}
        variant={'system'}
        icon={'exclamation-triangle'}
        title={null}
        message={<span>This can only be done once. Make sure that there is the new code on your page before clicking the Migrate Now button.</span>}
        close={false}
      />}
      <br/>
      {![MIGRATION_STARTED, MIGRATION_COMPLETED].includes(migrationStatus) && <Button
        name={'migratedata'}
        type={'action'}
        variant={'primary'}
        text={'Migrate Now'}
        icon={'random'}
        operation={'link'}
        behavior={'none'}
        action={''}
        iconRight={true}
        handleClick={handleMigrate}
        disabled={migrationStatus === MIGRATION_NOT_REQUIRED}
      />}
      <br/>
      {migrationStatus === MIGRATION_STARTED && <Loader />}
      {migrationStatus === MIGRATION_ERROR && <InlineMessage
        key={'meow'}
        display={true}
        name={'migrationmessage'}
        variant={'system'}
        icon={'exclamation-triangle'}
        title={null}
        message={<span>Something went wrong, please try again later</span>}
        close={false}
      />}
      {migrationStatus === MIGRATION_COMPLETED && <InlineMessage
        key={'meow'}
        display={true}
        name={'migrationmessage'}
        variant={'system'}
        icon={'exclamation-triangle'}
        title={null}
        message={<span>Migration competed successfully</span>}
        close={true}
      />}
      {migrationStatus === MIGRATION_NOT_REQUIRED && <InlineMessage
        key={'meow'}
        display={true}
        name={'migrationmessage'}
        variant={'system'}
        icon={'exclamation-triangle'}
        title={null}
        message={<span>Migration is not required</span>}
        close={true}
      />}
    </SectionCard>
  );
});


/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default SentimentAdvancedSettings;

